import request from '@/utils/request'
import { appCode } from '@/utils/dictionaries'

/**
 * 【人脸库】列表
 * @param {object} parameter
 */
export function listAiFaceLibrary (parameter) {
  return request({
    url: '/ai-meeting/sys/AiFaceLibrary/listAiFaceLibrary',
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【班前会重复计划】列表
 * @param {object} parameter
 */
export function listAiMeetingPlan (parameter) {
    return request({
      url: '/ai-meeting/sys/AiMeetingPlan/listAiMeetingPlan',
      method: 'get',
      params: { ...parameter, appCode }
    })
  }

/**
 * 【班前会重复计划】新增
 * @param {object} parameter
 */
export function saveAiMeetingPlan (parameter) {
  return request({
    url: '/ai-meeting/sys/AiMeetingPlan/saveAiMeetingPlan',
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会重复计划】编辑
 * @param {object} parameter
 */
export function updateAiMeetingPlan (parameter) {
  return request({
    url: '/ai-meeting/sys/AiMeetingPlan/updateAiMeetingPlan',
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会重复计划】启用/禁用
 * @param {object} parameter
 */
export function updateAiMeetingPlanStatus (parameter) {
  return request({
    url: '/ai-meeting/sys/AiMeetingPlan/updateAiMeetingPlanStatus',
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会重复计划】删除
 * @param {object} parameter
 */
export function deleteAiMeetingPlan (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlan/deleteAiMeetingPlanById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【班前会重复计划】查看
 * @param {object} parameter
 */
export function getAiMeetingPlanById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlan/getAiMeetingPlanById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 【班前会重复计划】冲突校验
 * @param {object} parameter - appCode, endTime, id, orgId, placeId, startDate, startTime
 */
export function checkRepeatMeetingPlan (parameter) {
  return request({
    url: '/ai-meeting/sys/AiMeetingPlan/checkRepeatMeetingPlan',
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会识别记录】列表
 * @param {object} parameter
 */
export function listAiFaceRecognitionLog (parameter) {
  return request({
    url: `/ai-meeting/sys/AiFaceRecognitionLog/listAiFaceRecognitionLog`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会预约】列表
 * @param {object} parameter
 */
export function listAiMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/listAiMeeting`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会预约】新增
 * @param {object} parameter
 */
export function saveAiMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/saveAiMeeting`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会预约】修改
 * @param {object} parameter
 */
export function updateAiMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/updateAiMeeting`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会预约】删除
 * @param {object} parameter
 */
export function deleteAiMeetingById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/deleteAiMeetingById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【班前会预约】查看
 * @param {object} parameter
 */
export function getAiMeetingById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/getAiMeetingById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【班前会配置】列表
 * @param {object} parameter
 */
export function listAiMeetingPlaceConfig (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/listAiMeetingPlaceConfig`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【设备管理】列表
 * @param {object} parameter
 */
export function listAiMeetingPlaceConfigForDeviceMgt (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/listAiMeetingPlaceConfig`,
    method: 'get',
    params: { ...parameter }
  })
}

/**
 * 【班前会配置】删除
 * @param {object} parameter
 */
export function deleteAiMeetingPlaceConfigById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/deleteAiMeetingPlaceConfigById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【班前会配置】保存
 * @param {object} parameter
 */
export function saveAiMeetingPlaceConfig (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/saveAiMeetingPlaceConfig`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会配置】修改
 * @param {object} parameter
 */
export function updateAiMeetingPlaceConfig (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/updateAiMeetingPlaceConfig`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会配置】查看
 * @param {object} parameter
 */
export function getAiMeetingPlaceConfigById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/getAiMeetingPlaceConfigById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【班前会配置】关联设备列表
 * @param {object} parameter
 */
export function listMonitoring (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/listMonitoring`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【账号管理】获取班组列表
 * @param {object} parameter
 */
export function listTeams (parameter) {
  return request({
    url: `/ai-meeting/sys/userApi/ListTeams/${parameter.orgId}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【账号管理】获取班组下人员
 * @param {object} parameter
 */
export function listTeamsUser (parameter) {
  return request({
    url: `/ai-meeting/sys/userApi/ListTeamsUser/${parameter.orgId}/${parameter.teamId}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【班前会台账】列表
 * @param {object} parameter
 */
export function listAiMeetingAccount (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/listAiMeetingRecord`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】新增/编辑
 * @param {object} parameter
 */
export function saveAiMeetingRecord (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/saveAiMeetingRecord`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】删除
 * @param {object} parameter
 */
export function deleteAiMeetingRecordById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/deleteAiMeetingRecordById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【班前会台账】查看
 * @param {object} parameter
 */
export function getAiMeetingRecordById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/getAiMeetingRecordById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【班前会台账】 参会情况饼图
 * @param {object} parameter
 */
export function participationSituation (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/participationSituation/${parameter.id}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【班前会台账】各班组参会情况及考勤率
 * @param {object} parameter
 */
export function teamAttendMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/teamAttendMeeting/${parameter.id}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】 参会人员列表
 * @param {object} parameter
 */
export function listMeetingAttendee (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/listMeetingAttendee`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】 截取视频
 * @param {object} parameter
 */
export function videoCapture (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/videoCapture`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】 预览截取视频
 * @param {object} parameter
 */
export function getVideoAddress (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/getVideoAddress`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【视频库 - 标签】列表
 * @param {object} parameter
 */
export function listAiVideoTag (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideoTag/listAiVideoTag`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【视频库 - 标签】保存
 * @param {object} parameter
 */
export function saveAiVideoTag (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideoTag/saveAiVideoTag`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}

/**
 * 【视频库 - 标签】修改
 * @param {object} parameter
 */
export function updateAiVideoTag (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideoTag/updateAiVideoTag`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【视频库 - 标签】查看
 * @param {object} parameter
 */
export function getAiVideoTagById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideoTag/getAiVideoTagById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【视频库 - 标签】删除
 * @param {object} parameter
 */
export function deleteAiVideoTag (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideoTag/deleteAiVideoTag/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【视频库 - 视频】列表
 * @param {object} parameter
 */
export function listAiVideo (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideo/listAiVideo`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【视频库 - 视频】保存
 * @param {object} parameter
 */
export function saveAiVideo (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideo/saveAiVideo`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}

/**
 * 【视频库 - 视频】修改
 * @param {object} parameter
 */
export function updateAiVideo (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideo/updateAiVideo`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}

/**
 * 【视频库 - 视频】查看
 * @param {object} parameter
 */
export function getAiVideo (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideo/getAiVideo/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 【视频库 - 视频】删除
 * @param {object} parameter
 */
export function deleteAiVideo (parameter) {
  return request({
    url: `/ai-meeting/sys/AiVideo/deleteAiVideo/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 【内置标准视频库 - 分组】列表
 */
export function listAiStandardVideoGroup (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideoGroup/listAiStandardVideoGroup`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【内置标准视频库 - 分组】保存
 */
export function saveAiStandardVideoGroup (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideoGroup/saveAiStandardVideoGroup`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}

/**
 * 【内置标准视频库 - 分组】修改
 */
export function updateAiStandardVideoGroup (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideoGroup/updateAiStandardVideoGroup`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}

/**
 * 【内置标准视频库 - 分组】删除
 */
export function deleteAiStandardVideoGroupById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideoGroup/deleteAiStandardVideoGroupById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 【内置标准视频库 - 视频】列表
 */
export function listAiStandardVideo (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideo/listAiStandardVideo`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【内置标准视频库 - 视频】保存
 */
export function saveAiStandardVideo (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideo/saveAiStandardVideo`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}

/**
 * 【内置标准视频库 - 视频】修改
 */
export function updateAiStandardVideo (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideo/updateAiStandardVideo`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}

/**
 * 【内置标准视频库 - 视频】详情
 */
export function getAiStandardVideoById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideo/getAiStandardVideoById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 【内置标准视频库 - 视频】引用详情
 */
export function listReferenceDetail (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideo/listReferenceDetail/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 【内置标准视频库 - 视频】删除
 */
export function deleteAiStandardVideoById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideo/deleteAiStandardVideoById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 【内置标准视频库 - 视频】流式播放
 */
export function playAiStandardVideoStream (parameter) {
  return request({
    url: `/ai-meeting/sys/AiStandardVideo/Stream/play/${parameter.id}`,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 【AI班前会数据看板】AI班前会今日概览
 * @param {object} parameter
 */
export function aiMeetingTodayOverview (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/aiMeetingTodayOverview`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【AI班前会数据看板】今日交底时长分析
 * @param {object} parameter
 */
export function teamTodayMeetingDuration (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/teamTodayMeetingDuration`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【数据看板】统计卡片
 * @param {object} parameter
 */
export function aiMeetingDataStatistics (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/aiMeetingDataStatistics`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【数据看板】各班组班前会开展次数与出勤率分析
 * @param {object} parameter
 */
export function teamMeetingCountAndRateAnalysis (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/teamMeetingCountAndRateAnalysis`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【数据看板】班前教育参会人数趋势
 * @param {object} parameter
 */
export function teamMeetingAttendTrend (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/teamMeetingAttendTrend`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【数据看板】班前教育参会人数趋势
 * @param {object} parameter
 */
export function monthlyMeetingActivityByTeam (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/monthlyMeetingActivityByTeam`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【数据看板】人员参会次数排行榜
 * @param {object} parameter
 */
export function aiMeetingAttendanceRanking (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/aiMeetingAttendanceRanking`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【数据看板】本月班前会详情
 * @param {object} parameter
 */
export function monthlyMeetingDetailByTeam (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/monthlyMeetingDetailByTeam`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【数据看板】今日班前会三交质量分析（按班组）
 * @param {object} parameter
 */
export function todayMeetingThreeQualityAnalysis (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/todayMeetingThreeQualityAnalysis`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【数据看板】日历图
 * @param {object} parameter
 */
export function aiMeetingCalendarChart (parameter) {
  return request({
    url: `/ai-meeting/sys/DataDashboard/aiMeetingCalendarChart`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【会议预约】开始
 * @param {object} parameter
 */
export function startAiMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/startAiMeeting/${parameter.id}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【会议预约】结束
 * @param {object} parameter
 */
export function stopAiMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/stopAiMeeting/${parameter.id}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【会议预约】新增会议重复校验
 * @param {object} parameter
 */
export function checkRepeatMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/checkRepeatMeeting`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【AI班前会设备管理】新增
 * @param {object} parameter
 */
export function saveAiMeetingDevice (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/saveAiMeetingDevice`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}

/**
 * 【AI班前会设备管理】编辑
 * @param {object} parameter
 */
export function updateAiMeetingDevice (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/updateAiMeetingDevice`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}
